import { render } from "./MeiliLogsList.vue?vue&type=template&id=90bec336"
import script from "./MeiliLogsList.vue?vue&type=script&lang=js"
export * from "./MeiliLogsList.vue?vue&type=script&lang=js"

import "./MeiliLogsList.vue?vue&type=style&index=0&id=90bec336&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__